import { createContext } from 'react';

import { IconOption } from '@components/base';
import { TMenuItemPreview, TPageSectionItemPreview } from '@models/LayoutPreview';

export type SourceIcon = { icon: IconOption; url?: undefined } | { icon?: undefined; url: string };

export type SourceIconValues = {
  getSourceIcon: (
    item: TMenuItemPreview | TPageSectionItemPreview,
    displayProviderIcon?: boolean
  ) => SourceIcon | undefined;
};

const SourceIconContext = createContext<SourceIconValues>({
  getSourceIcon: () => void 0,
});

export default SourceIconContext;
